import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from "../common/service/mpvAppConfigService";
import { HttpApiService } from "../common/service/mpvHttpApiService";
import { SigedCommonService } from "../siged-common.service";
import { AuthService } from './auth.service';

export interface PersonaRequestBody {
    "idPersona"?: string
    "username": string
    "clave": string
    "nombres": string
    "apellidos": string
    "idArea": string
    "idJefe": string
    "correo": string
    "idCargo": string
    "numeroIdentificacion": string
    "estado": string
    "requiereAprobacion": string
    "firmaLocal": string
    "firmaMovil": string
    "firmaMovilUsuario": string
    "firmaMovilClave": string
    "cambioConfidencial": string
    "visible": string
    "idPadre"?: null,

    perfiles: any[]
    roles: any[]
}

@Injectable({
    providedIn: 'root'
})
export class PersonaService {
    private _defaultHeaders;
    baseUrl = this.mpvCommonService.APPLICATION_API_HOST + "/";

    constructor(
        public httpApiService: HttpApiService,
        public appConfigService: AppConfigService,
        public mpvCommonService: SigedCommonService,
        private authService: AuthService,
        private http: HttpClient,
    ) {
        this._defaultHeaders = {
            Authorization: 'Bearer ' + this.authService.getUser()
        }
    }

    perfil(username): any {
        return this.httpApiService.get(
            this.baseUrl,
            "persona/perfil/" + username
        );
    }

    getDataPersona(idPersona): any {
        return this.httpApiService.get(
            this.baseUrl,
            "persona/sedeUser/" + idPersona
        );
    }

    getPersona(type, number): any {
        return this.httpApiService.getTimeOut(
            this.mpvCommonService.APPLICATION_API_HOST,
            "/persona/" + type + "/" + number, 8000
        );
    }

    adminAutoasignado(estado: any) {
        return this.httpApiService.get(
            this.baseUrl,
            "persona/adminAutoasignado/" + estado
        );
    }

    obtenerPorArea(number: number): Promise<any> {
        return this.httpApiService.get(
            this.baseUrl,
            "persona/area/" + number
        );
    }

    obtenerPorAreaBusqueda(number: number, q) {
        return this.httpApiService.get(
            this.baseUrl,
            "persona/area/" + number + "/busqueda?q=" + q
        );
    }

    saveAutoasignacion(tramite: any) {
        return this.httpApiService.post(
            this.baseUrl,
            "persona/guardarPersonaAutoAsignacion", tramite
        );
    }

    lista(
        params: { size?: string, page?: string },
        body: {
            "username": string,
            "nombres": string,
            "idArea": string
        }, //Se usa body cuando es POST
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        this._defaultHeaders = {
            Authorization: 'Bearer ' + this.authService.getUser()
        }
        const options = { params, headers: { ... this._defaultHeaders, ...headers } }
        return this.http.post(`${this.baseUrl}persona/listar`, body, options).toPromise();
    }

    detalle(
        params: { idPersona: string },
        headers?
    ): Promise<any> {
        this._defaultHeaders = {
            Authorization: 'Bearer ' + this.authService.getUser()
        }
        const options = { params, headers: { ... this._defaultHeaders, ...headers } }
        return this.http.get(`${this.baseUrl}persona/abrir`, options).toPromise();
    }

    actualizar(
        body: PersonaRequestBody,
        headers?
    ) {
        this._defaultHeaders = {
            Authorization: 'Bearer ' + this.authService.getUser()
        }
        const options = { headers: { ... this._defaultHeaders, ...headers } }
        return this.http.post(`${this.baseUrl}persona/actualizar`, body, options).toPromise();
    }

    actualizarNotiEmail(
        body: PersonaRequestBody,
        headers?
    ) {
        this._defaultHeaders = {
            Authorization: 'Bearer ' + this.authService.getUser()
        }
        const options = { headers: { ... this._defaultHeaders, ...headers } }
        return this.http.post(`${this.baseUrl}persona/actualizarNotiEmail`, body, options).toPromise();
    }

    actualizarPopUpInicio(
        body: PersonaRequestBody,
        headers?
    ) {
        this._defaultHeaders = {
            Authorization: 'Bearer ' + this.authService.getUser()
        }
        const options = { headers: { ... this._defaultHeaders, ...headers } }
        return this.http.post(`${this.baseUrl}persona/actualizarPopUpInicio`, body, options).toPromise();
    }

    crear(
        body: PersonaRequestBody,
        headers?
    ) {
        this._defaultHeaders = {
            Authorization: 'Bearer ' + this.authService.getUser()
        }
        const options = { headers: { ... this._defaultHeaders, ...headers } }
        return this.http.post(`${this.baseUrl}persona/crear`, body, options).toPromise();
    }

    EliminarPersona(
        body: {
            "estado": string,
            "idPersona": number,
        },
        headers?
    ) {
        this._defaultHeaders = {
            Authorization: 'Bearer ' + this.authService.getUser()
        }
        const options = { headers: { ... this._defaultHeaders, ...headers } }
        return this.http.post(`${this.baseUrl}persona/eliminar`, body, options).toPromise();
    }

    permisoFirmaMovil(idPersona: number): Promise<any> {
        return this.httpApiService.get(
            this.baseUrl,
            "persona/consultaFirmaMovil/" + idPersona
        );
    }
}
